import Service from "../../Services";

const LandingPage = {
  namespaced : true,
  state : {
    form : {
      id : '',
      is_active : true,
      title : '',
      start_date : '',
      end_date : '',
      button_color : '',
      background_type : '',
      font_color : '',
      background_color : '',
      background_image : '',
      background_image_show : '',
      cover_image_desktop : '',
      cover_image_desktop_show : '',
      cover_image_mobile : '',
      cover_image_mobile_show : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id : '',
        is_active : '',
        title : '',
        start_date : '',
        end_date : '',
        button_color : '',
        background_type : '',
        font_color : '',
        background_color : '',
        background_image : '',
        cover_image_desktop : '',
        cover_image_mobile : '',
      }
    }
  },
  actions : {
    getLandingPage({commit},{page,search,sort_start}){
      return Service.LandingPageAPI.getLandingPage(page,search,sort_start);
    },
    showLandingPage({commit},id){
      return Service.LandingPageAPI.showLandingPage(id);
    },
    saveLandingPage({commit},{id,data}){
      if(id){
        return Service.LandingPageAPI.updateLandingPage(id,data);
      }else{
        return Service.LandingPageAPI.createLandingPage(data);
      }
    },
    deleteLandingPage({commit},id){
      return Service.LandingPageAPI.deleteLandingPage(id);
    },
    setFormLandingPage({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default LandingPage
